import React from 'react'
import { AppointmentData, setSelectedPatient } from '../appointmentsSlice'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../../app/hooks'
import KeycloakService from '../../../utils/keycloakService'
import { CREATE_VISIT, HISTORY_READ } from '../../../utils/roles'
import { startSxpProxy } from '../../../utils/api'
import { OPD_PROJECT_ID } from '../../../utils/constants'
import {
  dental,
  general,
  getEncounter,
  physio,
  cancerScreening,
  visitType,
} from '../models'
import { setOpdPatientData } from '../../opd/OpdPatientSlice'

type Props = {
  appointment: AppointmentData
}

const VisitLink = ({ appointment }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const handleVisitClick = () => {
    dispatch(setSelectedPatient(appointment.patientId))
    if (appointment.encounter) {
      startSxpProxy(OPD_PROJECT_ID, getEncounter, {
        encounterId: appointment.encounter,
      }).then((data) => {
        dispatch(
          setOpdPatientData({
            ...appointment,
            muhId: appointment?.patientUhid,
            visitStatus: data?.data?.data?.status,
            PatientNumber: appointment?.patientNumber,
          })
        )
        const appointmentType = data?.data?.data?.type?.[0]?.coding?.find(
          (e: any) => e.code === visitType
        )?.display

        if (appointmentType === general || !appointmentType) {
          if (KeycloakService.hasRole([HISTORY_READ])) {
            navigate(`/visits/${appointment.encounter}/vitals`)
          }
        }
        if (appointmentType === physio) {
          if (KeycloakService.hasRole([HISTORY_READ])) {
            navigate(`/visits/${appointment.encounter}/physio/vitalsPhysio`)
          }
        }
        if (appointmentType === dental) {
          if (KeycloakService.hasRole([HISTORY_READ])) {
            navigate(`/visits/${appointment.encounter}/dental/vitalsDental`)
          }
        }
        if (appointmentType === cancerScreening) {
          if (KeycloakService.hasRole([HISTORY_READ])) {
            navigate(`/visits/${appointment.encounter}/cancerScreening/vitals`)
          }
        }
      })
    } else {
      // navigate('/opd', {
      //   state: {
      //     MUHId: appointment?.patientUhid,
      //     appointmentId: appointment?.id,
      //     openDialog: true,
      //   },
      // })
      if (KeycloakService.hasRole([CREATE_VISIT])) {
        navigate(`${appointment.id}/create-visit`)
      }
    }
  }

  const hasAccess =
    (appointment.encounter && KeycloakService.hasRole([HISTORY_READ])) ||
    (!appointment.encounter && KeycloakService.hasRole([CREATE_VISIT]))

  return (
    <button
      title={
        appointment.encounter ? 'Click to View Visit' : 'Click to Create Visit'
      }
      className={`visitLink ${hasAccess ? '' : 'auth-disabled'}`}
      onClick={() => handleVisitClick()}
    >
      Visit
    </button>
  )
}

export default VisitLink
